"use client"
import {useSession} from "next-auth/react";
import {Button} from "@/components/ui/button";
import QrCode from "@/components/site/QrCode";
import ApplyEvent from "@/app/(event)/events/[id]/applyEvent";
import { AddToCalendarButton } from 'add-to-calendar-button-react';
import {reworkDate} from "@/lib/helpers/reworkDate";
import {useRouter} from "next/navigation";
import {useEffect, useState} from "react";
import axios from "@/lib/axios";
export default function PreRegisterOpenTrainingButton({idEvent,date_event,participants, place_max,name,price,nbTicket}){
    const session = useSession();
    const router = useRouter();


    const eventDate = new Date(date_event);
    const dateNow = new Date();

    const participantCount = participants.length;
    let isParticip = false;

    if(session.status === "authenticated"){
        const userParticipate = participants.find(el => el.user_id === session.data.user.user.id)

        if(userParticipate){
            isParticip = true;
        }
    }

    if(dateNow > eventDate){
        return(
            <p className={"italic text-primary"}>L&apos;évennement est terminé vous ne pouvez plus vous inscrire.</p>
        )
    }



    if(isParticip){
        return (
            <div>
                <div className={"flex flex-col items-center gap-y-5"}>


                    <QrCode id={idEvent} type={"event"}/>
                    <p className={"text-primary text-center font-bold"}>Vous êtes inscrit veuillez montrer ce QrCode à l&apos;accueil</p>


                    {/*<QrCode/>*/}
                    {/*<p className={"text-primary text-center font-bold"}>Vous êtes inscrit veuillez montrer ce QrCode à l&apos;accueil</p>*/}
                    <AddToCalendarButton
                        name={name}
                        options={["Apple", 'Google', "Outlook.com"]}
                        startDate={reworkDate(eventDate,false,'en')}
                        timeZone={"Europe/Paris"}
                        label={"Noter dans mon agenda"}
                        inline
                        listStyle={"modal"}
                    />
                </div>

            </div>

        );
    }

    if(participantCount === place_max){
        return(
            <p className={"italic text-primary"}>Le nombre de place maximale pour cet évennement est atteint.</p>
        )
    }

    return(
        <ApplyEvent eventId={idEvent} onSuccess={() => router.refresh()} price={price} nbTicket={nbTicket}/>
    )



}
